// All task actions

import * as types from './actions';

export function addTask (task){
  return {
    type: types.ADD_TASK,
    task: task
  };
}

export function removeTask (index){
  return {
    type: types.REMOVE_TASK,
    index
  };
}



// WEBPACK FOOTER //
// ./client/actions/task-actions.js